import { Pipe, PipeTransform } from '@angular/core';
import { ObjectifPro } from '../../models/objectifPro';

@Pipe({
	name: 'filterObjectifProByName'
})
export class FilterObjectifProByNamePipe implements PipeTransform {
	transform(objectifPro: ObjectifPro[], filter: string): ObjectifPro[] {
		if (
			!objectifPro ||
			!filter ||
			objectifPro === null ||
			filter === null ||
			filter === ''
		) {
			return objectifPro;
		}

		return objectifPro.filter((objectifPro: ObjectifPro) => {
			if (objectifPro.name) {
				// TODO: add lastName too
				return objectifPro.name.toLowerCase().includes(filter.toLowerCase());
			}
			return false;
		});
	}
}
